import {AxiosResponse} from 'axios'
import axiosApi from '../api/axios-api'

export default {
    templateSetVersions(type: string): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/set/versions/${type}`, null)
			.then(function (response) { resolve(response); })
			.catch(function (error) { reject(error); });
		});
    },
    templateSetLoad(type: string, version: number): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/set/load/${type}/${version}`, null)
			.then(function (response) { resolve(response); })
			.catch(function (error) { reject(error); });
		});
    },
    templateSetSave(type: string, version: number, sheets: any[], deletedSheetIds: any[]): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/set/save/${type}/${version}`, { sheets, deletedSheetIds })
			.then(function (response) { resolve(response); })
			.catch(function (error) { reject(error); });
		});
    },
    templateSetDelete(type: string, version: number): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/set/delete/${type}/${version}`, null)
			.then(function (response) { resolve(response); })
			.catch(function (error) { reject(error); });
		});
    },
    templateNotification(): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/notification`, null)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    templateFind(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/find`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    templateSave(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/save`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    templateView(id: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/view/` + id, null)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    templateViewBySheet(id: any, request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/view/sheet/` + id, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	templateImportAll(request: any): Promise<AxiosResponse<any>>{
		return new Promise((resolve, reject)=>{
			axiosApi.axiosPostImport(`/template/import/all`, request)
				.then(function (response){
					resolve(response);
				})
				.catch(function(error){
					reject(error);
				})
		})
	},
    templateImportBySheet(id: any, request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostImport(`/template/import/sheet/` + id, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
	});
    },
    templateImportProceedBySheet(id:any, request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/import/proceed/` + id, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    templateExportBySheet(id: any, request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostExport(`/template/export/sheet/` + id, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	templateExportAll(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostExport(`/template/export/all`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	templateRevertBySheet(id: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/revert/sheet/` + id, null)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    templateUpdate(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/update`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    templateUpdateCached(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/update/cached`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    templatePublish(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/publish`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    templateClone(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/clone`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    templateList(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/list`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	templateDelete(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/template/delete`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
}
